/**
 * package: com.inq.ui
 * class: Label
 * @extends com.inq.ui.TextInput 
 * @constructor
 */
com.inq.ui.Label = function(text) {
	com.inq.ui.TextInput.call(this);
	this._div.innerHTML = "<input type=\"text\" style=\"height:100%;width:100%\"></input>";
	this._input = this._div.getElementsByTagName("input")[0];
	this._input.disabled = true;
	
	if(text != null) this._input.value = text;
};
$hxClasses.extend(com.inq.ui.TextInput, com.inq.ui.Label, "com.inq.ui.Label");
/** @type {com.inq.ui.Label} */
com.inq.ui.Label.prototype.__class__ = com.inq.ui.Label;
